import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useStore, { type StoreState } from 'services/store';

import useCurrentPage from './useCurrentPage';

const selector = (state: StoreState) => ({
  setLastSearch: state.searchQuery.setLastSearch,
});

const useSaveLastSearch = () => {
  const page = useCurrentPage();
  const location = useLocation();

  const { setLastSearch } = useStore(selector);

  useEffect(() => {
    if (!location.search.length) {
      return;
    }

    setLastSearch(page as string, location.search);
  }, [location.search, page, setLastSearch]);

  return null;
};

export default useSaveLastSearch;
